import axios from "axios";

const API_ENDPOINT =  /localhost/.test(location.href) | /sve\.test/.test(location.href) ? 'http://0.0.0.0:9192/api/' : (
    /(kbs|sve)\.nerdlichter\.com/.test(location.href) ? 'https://sve-help.nerdlichter.com/api/' : '/api/');

export default {
    documents(filter) {
        return axios.get(`${API_ENDPOINT}documents`, {
            params: filter
        });
    },

    categories() {
        return axios.get(`${API_ENDPOINT}categories`);
    },
}
